module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('b-container', {
    staticStyle: {
      "margin-top": "-24px",
      "padding": "0 15px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    ref: "category",
    staticClass: "text-center",
    style: ('line-height: ' + _vm.categoryHeight + 'px; background-color: #29363d; color: aliceblue; width: 100%; position: fixed; z-index: 50;'),
    attrs: {
      "align-v": "start"
    }
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(item, index) {
    return _c('b-col', {
      key: index
    }, [_c('div', {
      class: 'category ' + item.extraClass,
      on: {
        "click": function($event) {
          return _vm.changeTo(index)
        }
      }
    }, [_c('span', [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name))])])])
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  })], 2)], 1), _vm._v(" "), _c('b-container', {
    style: ('padding-top: ' + _vm.categoryHeight + 'px'),
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('h2', {
    ref: _vm.selectedCategory.code,
    staticClass: "categoryHead"
  }, [_vm._v(_vm._s(_vm.selectedCategory.name))])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }), _vm._v(" "), _c('b-col', [(_vm.changeSuccess) ? _c('b-tabs', {
    ref: "serviceTab",
    attrs: {
      "content-class": "mt-3",
      "fill": "",
      "active-nav-item-class": "font-weight-bold text-primary",
      "active-tab-class": "font-weight-bold"
    }
  }, [_vm._l((_vm.selectedService), function(service, s_index) {
    return [_c('b-tab', {
      key: s_index,
      attrs: {
        "title": service.name,
        "active": _vm.$route.params.initServiceCode ? service.code === _vm.$route.params.initServiceCode : s_index === 0,
        "title-link-class": "serviceHead"
      }
    }, [_c('b-form', {
      attrs: {
        "inline": ""
      }
    }, [_c('h1', {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(service.name))]), _vm._v(" "), _c('b-button', {
      attrs: {
        "to": {
          name: 'welcome-demos',
          params: {
            categoryCode: _vm.selectedCategory.code,
            serviceCode: service.code
          }
        },
        "size": "sm",
        "variant": "outline-primary"
      }
    }, [_vm._v("查看DEMO "), _c('i', {
      staticClass: "fa fa-angle-double-right"
    })])], 1), _vm._v(" "), (service.ismd) ? _c('v-md-preview', {
      staticClass: "serviceBrief",
      attrs: {
        "text": service.brief
      }
    }) : _c('div', {
      staticStyle: {
        "padding": "20px 12px !important"
      },
      domProps: {
        "innerHTML": _vm._s(service.brief)
      }
    })], 1)]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-501567ce!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/WelcomeNew.vue
// module id = 5tN7
// module chunks = 4